import Vue from 'vue'
export const findByPage = (params) => {
  return Vue.fetch.post('/apiv1/data/relay/findByPage', params)
}

// 根据appKey推送数据
export const rePushAll = (params) => {
  return Vue.fetch.post('/apiv1/data/relay/rePushAll', params)
}

// 根据id推送数据
export const rePushIds = (params) => {
  return Vue.fetch.post('/apiv1/data/relay/rePushIds', params)
}



// WEBPACK FOOTER //
// ./src/services/datapushApi.js